export const appConfig = {
  APP_NAME: process.env.VUE_APP_NAME,
  BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
}
